/**
 * Logout template.
 */
import Animator from '@components/elements/animator/animator';
import Body from '@components/sections/logout/logoutBody';
import Button from '@components/elements/logout/logoutButton';
import Container from '@components/atoms/container/logoutContainer';
import useLogoutTemplate from '../lib/useLogoutTemplate';
import { selectMenuCollapse } from '@shared/store/slices/menu.slice';
import { useAppSelector } from '@shared/store/hooks';

/**
 * Logout template component
 * Handles the logout functionality and display of the logout modal.
 *
 * @returns {JSX.Element} Logout container with logout information and button
 */
export default function LogoutTemplate() {
  // Hooks
  const { callbacks, props } = useLogoutTemplate();
  const menuExpanded = !useAppSelector(selectMenuCollapse);

  // Render
  return (
    <Animator
      id={'logoutContainer'}
      type={Animator.Type.SETTING}
      collapse={{ horizontal: menuExpanded }}
    >
      <Container {...props.container} {...callbacks.container}>
        <Body />
        <Button {...props.button} {...callbacks.button} />
      </Container>
    </Animator>
  );
}
